var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-2 sbtn",attrs:{"color":"primary","dark":"","to":"/staff/add"}},[_vm._v(_vm._s(_vm.$t("customers.list.new")))]),_c('DataTable',{attrs:{"url":_vm.api.ACTIONS.USERS,"titles":_vm.titles,"fields-hidden-main":[
      'deleted_at',
      'updated_at',
      'last_name',
      'profile_image',
      'phone_number',
      'identity',
      'telegram_username',
    ],"fields-hidden-add":[
      'id',
      'deleted_at',
      'created_at',
      'updated_at',
      'roles',
    ],"input-types-add":{
      password: 'password',
      password_confirmation: 'password',
    },"fields-extra-add":_vm.fieldsExtraAdd,"formatter":_vm.formatters,"title":_vm.$t('customers.list.title'),"enableEdit":false,"enableAdd":false,"actions-extra-main":_vm.actionsExtraMain}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }